import { findFormation, type Theme } from '@core/theme';

export interface FormQueryParams {
  situationPro?: number;
  objectif?: number;
  domainId?: number;
  idFormationBitrix?: number;
  etape?: number;
}

export const resolveFormQueryParams = ({
  formQueryParams,
  themes,
}: {
  formQueryParams: FormQueryParams;
  themes: Theme[];
}): FormQueryParams => {
  const { situationPro, objectif, domainId, idFormationBitrix, etape } =
    formQueryParams;

  const hasValidDomain =
    domainId !== undefined && themes.some((theme) => theme.id === domainId);

  const hasValidTraining =
    hasValidDomain &&
    idFormationBitrix !== undefined &&
    findFormation({ themes, id: idFormationBitrix }) !== null;

  return {
    situationPro,
    objectif,
    domainId: hasValidDomain ? domainId : undefined,
    idFormationBitrix: hasValidTraining ? idFormationBitrix : undefined,
    etape,
  };
};

export const readFormQueryParams = (): FormQueryParams => {
  const params = new URLSearchParams(window.location.search);

  const isManualLead = params.get('utm_source') === 'manuel';
  if (isManualLead) {
    return {};
  }

  return {
    situationPro: toNumber(params.get('situationPro')),
    objectif: toNumber(params.get('objectif')),
    domainId: toNumber(params.get('domain')),
    idFormationBitrix: toNumber(params.get('training')),
    etape: toNumber(params.get('etape')),
  };
};

const toNumber = (raw: string | null): number | undefined => {
  if (raw === null || raw.trim() === '') {
    return undefined;
  }
  const value = Number(raw);
  return Number.isNaN(value) ? undefined : value;
};
